/*
 * @Descripttion:
 * @Author: Junteng Shi
 * @Date: 2025-03-06 14:58:24
 * @LastEditors: HongJian Liu
 * @LastEditTime: 2025-06-10 09:30:48
 */
import { defineStore } from 'pinia';
import { getAllAreas } from '@/api/app/index';
import piniaStore from '@/store/index';

export const useAppStore = defineStore('app', {
  state: () => ({
    menuList: [],
    initMenus: [],
    isMenuLoaded: false,
    mapOptions: [],
  }),
  getters: {},
  actions: {
    setMenuList(menuList: any) {
      this.menuList = menuList;
    },
    setInitMenus(menu: any) {
      this.initMenus = menu;
    },
    setMenuLoaded(isMenuLoaded: boolean) {
      this.isMenuLoaded = isMenuLoaded;
    },
    setMapOptions(mapOptions: any) {
      this.mapOptions = mapOptions;
    },
    async fetchMapOptions() {
      try {
        if (this.mapOptions.length > 0) {
          console.log('Map options already loaded:', this.mapOptions);
          return;
        } else {
          const res = await getAllAreas();
          this.setMapOptions(res);
        }
      } catch (error) {
        console.error('Error fetching map options:', error);
      }
    },
  },
  persist: {
    storage: localStorage,
  },
});

export function useAppOutsideStore() {
  return useAppStore(piniaStore);
}
